export class RequestDetails{
    adjudicationId: string;
    engagementId: string;
    pageNumber: number;
    pageSize: number;
    sortColumn: any;
    sortOrder: any;
}

export enum SupportingDocumentClaimsGridColumn {
    dateSent = 'DATESENT',
    action = 'ACTIONNAME',
    status = 'STATUSNAME',
    statusUpdatedDate = 'STATUSUPDATEDDATE'
  }